import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { TutorialLayer } from "../TutorialLayer";

export class MatchOverLayer extends Phaser.Group {

    private tutorialLayer: Phaser.Group;
    private won: boolean;
    private scaledItemsContainer: Phaser.Group;
    private resultImage: Phaser.Image;
    private tutorialButton: Phaser.Button;

    constructor(game: Phaser.Game, won: boolean) {

        super(game, null, "match-over-layer");

        this.won = won;

        const tmpBackground = <Phaser.Sprite> this.create(0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        tmpBackground.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
        tmpBackground.alpha = 0;
        tmpBackground.inputEnabled = true;
        tmpBackground.events.onInputDown.add(function (): void {
            // no hacer nada
        }, this);

        this.scaledItemsContainer = new Phaser.Group(this.game);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scale.y = GameVars.scaleY;
        this.add(this.scaledItemsContainer);

        this.resultImage = new Phaser.Image(this.game, 0, -250, "texture_atlas_1", won ? "text_win" : "text_gameover");
        this.resultImage.anchor.set(.5);
        this.resultImage.alpha = 0;
        this.scaledItemsContainer.add(this.resultImage);

        let bestLabel = null;

        if (won) {

            const pulseTween = this.game.add.tween(this.resultImage.scale);
            pulseTween.to({ x: 1.05, y: .95}, 300, Phaser.Easing.Linear.None, false);
            pulseTween.delay(50);
            pulseTween.to({ x: .95, y: 1.05}, 700, Phaser.Easing.Elastic.Out);
            pulseTween.loop();
            pulseTween.start();

            bestLabel = new Phaser.Text(this.game, 0, -20, "BEST: " + GameVars.secondsToTime(GameVars.gameData.highscores[GameVars.difficulty].score), {font: "50px Eczar", fill: "#FFFFFF"});
            bestLabel.anchor.set(.5);
            bestLabel.visible = false;
            this.scaledItemsContainer.add(bestLabel);
        }

        const easyButton = new Phaser.Button(this.game, -200, 200, "texture_atlas_1", this.onClickPlay, this);
        easyButton.setFrames("btn_sq_easy", "btn_sq_easy", "btn_sq_easy", "btn_sq_easy");
        easyButton.anchor.set(.5);
        easyButton.name = GameConstants.DIFFICULTY_EASY;
        easyButton.visible = false;
        this.scaledItemsContainer.add(easyButton);

        const mediumButton = new Phaser.Button(this.game, 0, 200, "texture_atlas_1", this.onClickPlay, this);
        mediumButton.setFrames("btn_sq_medium", "btn_sq_medium", "btn_sq_medium", "btn_sq_medium");
        mediumButton.anchor.set(.5);
        mediumButton.name = GameConstants.DIFFICULTY_MEDIUM;
        mediumButton.visible = false;
        this.scaledItemsContainer.add(mediumButton);

        const hardButton = new Phaser.Button(this.game, 200, 200, "texture_atlas_1", this.onClickPlay, this);
        hardButton.setFrames("btn_sq_hard", "btn_sq_hard", "btn_sq_hard", "btn_sq_hard");
        hardButton.anchor.set(.5);
        hardButton.name = GameConstants.DIFFICULTY_HARD;
        hardButton.visible = false;
        this.scaledItemsContainer.add(hardButton);

        const easyLabel = new Phaser.Text(this.game, -200, 290, "EASY", {font: "36px Eczar", fill: "#FFFFFF"});
        easyLabel.anchor.set(.5);
        easyLabel.visible = false;
        this.scaledItemsContainer.add(easyLabel);

        const mediumLabel = new Phaser.Text(this.game, 0, 290, "MEDIUM", {font: "36px Eczar", fill: "#FFFFFF"});
        mediumLabel.anchor.set(.5);
        mediumLabel.visible = false;
        this.scaledItemsContainer.add(mediumLabel);

        const difficultLabel = new Phaser.Text(this.game, 200, 290, "HARD", {font: "36px Eczar", fill: "#FFFFFF"});
        difficultLabel.anchor.set(.5);
        difficultLabel.visible = false;
        this.scaledItemsContainer.add(difficultLabel);

        this.tutorialButton = new Phaser.Button(this.game, 0, difficultLabel.position.y + 150, "texture_atlas_1", this.onClickTutorial, this);
        this.tutorialButton.setFrames( "btn_info", "btn_info", "btn_info", "btn_info");
        this.tutorialButton.anchor.set(.5);
        this.tutorialButton.visible = false;
        this.scaledItemsContainer.add(this.tutorialButton);

        let t = won ? 250 : 750;
        
        this.game.add.tween(tmpBackground)
            .to ({ alpha: .65 }, 450, Phaser.Easing.Cubic.Out, true, t);

        this.game.add.tween(this.resultImage)
            .to ({ alpha: 1 }, 450, Phaser.Easing.Cubic.Out, true, t + 500)
            .onComplete.add(function(): void {

                if (bestLabel) {
                    bestLabel.visible = true;
                }

                easyButton.visible = true;
                mediumButton.visible = true;
                hardButton.visible = true;
                
                this.tutorialButton.visible = true;

                easyLabel.visible = true;
                mediumLabel.visible = true;
                difficultLabel.visible = true;

                if (this.won) {
                    AudioManager.playSound("loop_fireworks_win");
                }
                
            }, this);

        AudioManager.changeSoundVolume("soundtrack_loop", .2);
    }

    public destroy(): void {

        super.destroy();

        if (this.won) {
            AudioManager.stopSound("loop_fireworks_win");
        }
    }

    public update(): void {

        super.update();

        if (this.won && this.resultImage.alpha === 1) {

            if (Math.random() > .96) {

                const px = 300 - 600 * Math.random();
                const py = -50 - 200 * Math.random();

                const fireworks = <Phaser.Sprite> this.scaledItemsContainer.create(px, py, "texture_atlas_1", "fireworks_01");
                fireworks.anchor.set(.5);
                fireworks.animations.add("explode", Phaser.Animation.generateFrameNames("fireworks_", 1, 25, "", 2));
                fireworks.animations.play("explode", 20, false, true);

                const s = 1 + Math.random() * .75;
                let sign = Math.random() > .5 ? -1 : 1;

                fireworks.scale.set(sign * s, s);

                const rnd = Math.random();

                if (rnd > .6) {
                    fireworks.tint = 0xFF4168;
                } else if (rnd > .3) {
                    fireworks.tint = 0xFE8B29;
                } else {
                    fireworks.tint = 0xFFEE56;
                }

                this.scaledItemsContainer.sendToBack(fireworks);
            }
        }
    }

    public closeTutorial(): void {
        
        this.tutorialLayer.destroy();
        this.tutorialLayer = null;
    }

    private onClickPlay(b: Phaser.Button): void {

        this.game.camera.fade(0x3d2c2e, 350);
        this.game.camera.onFadeComplete.add(function(): void {
            GameManager.enterBoardScene(b.name);
        }, this);

        GameManager.enterBoardScene(b.name);

        AudioManager.playSound("btn_click");
    }

    private onClickTutorial(): void {

        this.tutorialLayer = new TutorialLayer(this.game);
        this.add(this.tutorialLayer);
        GameVars.tutorialFromSplash = false;

        AudioManager.playSound("btn_click");
    }
}
